import React from 'react';

const Logo = ({ className = "" }: { className?: string }) => (
  <div className={`flex items-center gap-2 sm:gap-4 ${className}`}>
    <div className="flex items-center gap-1 sm:gap-1.5 shrink-0">
      {/* The 'I' part */}
      <div className="border-2 sm:border-[3px] border-red-600 p-[1px] sm:p-[2px] h-10 w-5 sm:h-14 sm:w-8 shrink-0">
        <div className="bg-red-600 h-full w-full"></div>
      </div>
      
      {/* The Bearing part */}
      <div className="relative w-10 h-10 sm:w-16 sm:h-16 flex items-center justify-center shrink-0">
        <div className="absolute inset-0 border-[3px] sm:border-[5px] border-red-600 rounded-full"></div>
        <div className="absolute inset-[6px] sm:inset-[10px] border-2 sm:border-[3px] border-red-600 rounded-full flex items-center justify-center">
          <div className="w-3.5 h-3.5 sm:w-6 sm:h-6 bg-red-600 rounded-full flex items-center justify-center">
             <div className="w-1.5 h-1.5 sm:w-3 sm:h-3 bg-white rounded-full opacity-20"></div>
          </div>
        </div>
        {/* Ball bearings - Mobile */}
        <div className="absolute inset-0 sm:hidden">
          {[...Array(12)].map((_, i) => (
            <div 
              key={`m-${i}`} 
              className="absolute w-1.5 h-1.5 bg-red-600 rounded-full left-1/2 top-1/2 -ml-[3px] -mt-[3px]" 
              style={{ 
                transform: `rotate(${i * 30}deg) translateY(-12px)`
              }}
            />
          ))}
        </div>
        {/* Ball bearings - Desktop */}
        <div className="absolute inset-0 hidden sm:block">
          {[...Array(12)].map((_, i) => (
            <div 
              key={`d-${i}`} 
              className="absolute w-2.5 h-2.5 bg-red-600 rounded-full left-1/2 top-1/2 -ml-[5px] -mt-[5px]" 
              style={{ 
                transform: `rotate(${i * 30}deg) translateY(-20px)`
              }}
            />
          ))}
        </div>
      </div>
    </div>
    
    {/* Text part */}
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-0 sm:gap-2 shrink-0">
      <span className="text-xl sm:text-4xl font-bold text-red-600 tracking-tighter whitespace-nowrap">Onkar Bearing</span>
      <span className="text-[15px] sm:text-2xl font-bold text-red-600 whitespace-nowrap">Pvt. Ltd.</span>
    </div>
  </div>
);

export default Logo;
